import { type FC } from 'react'
import { AccountNameV2Page } from '../v2/account-name-v2'

export const AccountNameWrapperPage: FC = () => {
  return <AccountNameV2Page />
}
